<template>
  <div>
    <el-popover
      placement="top-start"
      trigger="hover"
      popper-class="layout-popover"
      v-model="networkVisible"
    >
      <div class="network-list">
        <div class="net-item">
          <div class="label">房间号：</div>
          <div class="value">{{ roomInfo.id }}</div>
        </div>
        <div class="net-item">
          <div class="label">用户ID：</div>
          <div class="value">
            {{ userInfo.user_id }}
          </div>
        </div>
        <div class="net-item">
          <div class="label">客户端：</div>
          <div class="value">{{ platform }}</div>
        </div>
        <div class="net-item" v-if="isElectron">
          <div class="label">版本号：</div>
          <div class="value">
            {{ appVersion }}
          </div>
        </div>
        <div class="net-footer">
          <log v-if="isElectron" @uploadSuccess="networkVisible = false" />
          <el-button type="primary" @click="onClickCopy">全部复制</el-button>
        </div>
      </div>
      <div slot="reference">
        <img
          class="reference-img"
          src="@saas/pages/assets/images/live/system-info.png"
          alt=""
        />
      </div>
    </el-popover>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { copyText } from "@saas/components/src/utils/utils";
import ScreenShareMixins from "../mixins/screen-share";
import Log from "./Log.vue";
const isMac = () => {
  return /macintosh|mac os x|macintel/i.test(navigator.userAgent.toLowerCase());
};
export default {
  mixins: [ScreenShareMixins],
  components: {
    Log,
  },
  data() {
    return {
      networkVisible: false,
      isElectron: window.isElectron,
      isMac: isMac(),
      appVersion: "",
    };
  },
  async mounted() {
    await this.getAppVersion();
  },
  beforeDestroy() {},
  computed: {
    ...mapState("live", ["liveService", "roomInfo"]),
    userInfo() {
      return this.$store.getters.user || {};
    },
    platform() {
      if (this.isElectron) {
        // Electron客户端
        if (this.isMac) {
          return "Mac";
        } else {
          return "Windows";
        }
      } else {
        // 网页端，返回具体浏览器信息
        return this.getBrowserInfo();
      }
    },
  },
  watch: {},
  methods: {
    // 获取应用版本号
    async getAppVersion() {
      if (this.isElectron) {
        // Electron客户端，从主进程获取版本号
        if (window.LiveElectronApi && window.LiveElectronApi.getAppVersion) {
          try {
            this.appVersion = await window.LiveElectronApi.getAppVersion();
          } catch (error) {
            console.error("获取Electron版本号失败:", error);
            this.appVersion = this.getElectronVersion();
          }
        } else {
          // 如果没有专门的API，尝试从package.json获取
          this.appVersion = this.getElectronVersion();
        }
      }
    },

    // 获取Electron版本号
    getElectronVersion() {
      try {
        // 尝试从全局变量获取
        if (window.electronStore) {
          return window.electronStore.get("appVersion") || "1.0.0";
        }
        return "1.0.0";
      } catch (error) {
        console.error("获取Electron版本号失败:", error);
        return "1.0.0";
      }
    },

    // 获取浏览器信息
    getBrowserInfo() {
      const userAgent = navigator.userAgent;

      // Chrome
      if (
        userAgent.includes("Chrome") &&
        !userAgent.includes("Edg") &&
        !userAgent.includes("OPR") &&
        !userAgent.includes("Opera")
      ) {
        return "Chrome";
      }

      // Edge (Chromium)
      if (userAgent.includes("Edg")) {
        return "Edge";
      }

      // Firefox
      if (userAgent.includes("Firefox")) {
        return "Firefox";
      }

      // Safari
      if (userAgent.includes("Safari") && !userAgent.includes("Chrome")) {
        return "Safari";
      }

      // Opera
      if (userAgent.includes("OPR") || userAgent.includes("Opera")) {
        return "Opera";
      }

      // 其他浏览器
      return "Web";
    },

    onClickCopy() {
      // 创建包含换行的文本，去掉多余空格
      let textToCopy = "";
      if (this.isElectron) {
        textToCopy = `房间号：${this.roomInfo.id}
用户ID：${this.userInfo.user_id}
客户端：${this.platform}
版本号：${this.appVersion}`;
      } else {
        textToCopy = `房间号：${this.roomInfo.id}
用户ID：${this.userInfo.user_id}
客户端：${this.platform}`;
      }

      try {
        // 使用 Clipboard API 复制文本
        copyText(textToCopy).then(() => {
          this.$darkMessage.success("复制成功");
          this.networkVisible = false;
        });
      } catch (err) {
        this.$darkMessage.error("复制失败");
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.reference-img {
  width: 20px;
  height: 20px;
  cursor: pointer;
}
.network-list {
  width: 327px;
  background: #18181b;
  box-shadow: 0px 8px 60px 2px rgba(0, 0, 0, 0.8);
  border-radius: 12px 12px 12px 12px;
  border: 1px solid rgba(229, 231, 235, 0.04);
  display: flex;
  flex-direction: column;
  padding: 16px;
  .title {
    display: flex;
    justify-content: center;
    align-items: center;
    font-weight: 600;
    height: 28px;
    font-size: 18px;
    color: #c9cdd4;
    img {
      width: 20px;
      height: 20px;
      margin-right: 12px;
    }
  }
  .net-item {
    height: 36px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    .label {
      font-weight: 400;
      font-size: 14px;
      color: #a1a1aa;
    }
    .value {
      font-weight: 500;
      font-size: 14px;
      color: #ecedee;
      text-align: left;
    }
  }
  .net-footer {
    display: flex;
    justify-content: space-between;
    align-items: center;
    .el-button {
      flex: 1;
      margin-top: 16px;
      border-radius: 12px;
      border: none;

      &:first-child {
        background: #3f3f46;
        color: #ecedee;
        &:hover {
          background: #3f3f46 !important;
        }
        &:active {
          background: #3f3f46 !important;
        }
        &:focus {
          background: #3f3f46 !important;
        }
      }
      &:last-child {
        background: #0e42d2;
        color: #e8f3ff;
        &:hover {
          background: #0e42d2 !important;
        }
        &:active {
          background: #0e42d2 !important;
        }
        &:focus {
          background: #0e42d2 !important;
        }
      }
    }
  }
}
.platform-check {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 9999;
}
</style>
<style lang="scss">
.layout-popover {
  background: #18181b;
  border-radius: 12px 12px 12px 12px;
  border: 1px solid rgba(229, 231, 235, 0.04) !important;
  box-shadow: 0px 8px 60px 2px rgba(0, 0, 0, 0.8) !important;
  padding: 0;
  z-index: 9999;
  .popper__arrow {
    display: none;
  }
}
</style>
